import React from 'react';

import {
  Box,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';

const ToolbarPopover = ({ trigger, children }) => {
  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <Box>{trigger}</Box>
      </PopoverTrigger>
      <PopoverContent width="max-content" border="none">
        <PopoverArrow backgroundColor="surface.contrast" boxShadow="none" />
        <PopoverBody
          backgroundColor="surface.contrast"
          color="grey.900"
          p={3}
          borderRadius="md"
          boxShadow="md"
        >
          {children}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ToolbarPopover;
